import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSkrillLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "568px",
	height: "205px",
	viewBox: "0 0 568 205",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Slice 1" }),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			x1: "0.0176397954%",
			y1: "49.967269%",
			x2: "100.001623%",
			y2: "49.967269%",
			id: "linearGradient-1",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#872166",
				offset: "0%"
			}), /* @__PURE__ */ _jsx("stop", {
				stopColor: "#4F2455",
				offset: "100%"
			})]
		}) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Page-1",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Skrill-Logo",
				transform: "translate(0.000000, 5.000000)",
				fill: "url(#linearGradient-1)",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M451.7,19.7 L498.9,11.3 L498.9,192.4 L451.7,192.4 L451.7,19.7 Z M520.6,19.7 L520.6,192.3 L567.8,192.3 L567.8,11.3 L520.6,19.7 Z M384.6,192.3 L431.8,192.3 L431.8,59.9 L384.6,59.9 L384.6,192.3 Z M72.7,78.6 C66.7,78.2 52.9,77.3 52.9,64.9 C52.9,49.9 72.8,49.9 80.2,49.9 C93.3,49.9 110.3,53.8 122.4,57.4 C122.4,57.4 129.2,59.8 134.9,62.2 L135.4,62.3 L135.4,61.8 L135.4,21.3 L134.7,21.1 C120.4,16.1 103.8,11.3 72.9,11.3 C19.7,11.3 0.9,42.3 0.9,68.8 C0.9,84.1 7.5,120.1 68.4,124.3 C73.6,124.6 87.3,125.4 87.3,138.3 C87.3,148.9 76.1,155.2 57.2,155.2 C36.5,155.2 16.5,149.9 4.3,144.9 L4.3,187.2 C22.5,192 43.1,194.4 67.2,194.4 C119.2,194.4 142.5,165.1 142.5,136 C142.5,103 116.5,81.6 72.7,78.6 Z M358,58 C314.4,59.4 292.3,79 292.3,117.9 L292.3,192.4 L339.9,192.4 L339.9,131.6 C339.9,108.3 342.9,98.3 370.6,97.4 L370.6,58.6 C365.8,57.7 358,58 358,58 Z M230,59.8 C229,62.4 221.4,83.8 203.1,105.9 L203.1,11.3 L154.4,20.9 L154.4,192.3 L203.1,192.3 L203.1,139.3 C217.2,160.5 224.2,192.3 224.2,192.3 L282.5,192.3 C276.7,168.3 251.5,124.1 251.5,124.1 C274.1,95.4 284.1,64.8 285.7,59.7 L230,59.7 L230,59.8 Z M408.1,47.2 C420.9,47.2 431.4,36.8 431.4,24 C431.4,11.2 421,0.7 408.1,0.7 C395.3,0.7 384.9,11.1 384.9,24 C384.9,36.8 395.3,47.2 408.1,47.2 Z",
					id: "Shape"
				})
			})
		})
	]
});
export default SvgSkrillLogo;
